import React from "react";
import { rupee } from "../lib/api";
import logoNavy from "../assets/logo-navy.png";

export function Invoice({ invoice }) {
  if (!invoice) return null;
  const inv = invoice;
  return (
    <div className="bg-white p-8 text-charcoal" id="invoice-printable" data-testid="invoice-content">
      <div className="flex justify-between items-start border-b-2 border-navy pb-5">
        <div className="flex items-center gap-3">
          <img src={logoNavy} alt="Begum's Biryani Secret" className="h-12 w-auto" />
          <div>
            <div className="font-serif text-2xl text-navy">Begum's Biryani Secrets</div>
            <div className="text-xs text-gold italic">Royal Flavours. Timeless Tradition.</div>
          </div>
        </div>
        <div className="text-right text-sm">
          <div className="font-semibold text-navy">TAX INVOICE</div>
          <div className="text-muted-foreground">{inv.invoice_number}</div>
          <div className="text-muted-foreground text-xs mt-1">{new Date(inv.created_at).toLocaleString("en-IN")}</div>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-6 py-5 text-sm">
        <div>
          <div className="overline text-gold mb-1">Billed To</div>
          <div className="font-medium text-navy">{inv.customer.name}</div>
          <div className="text-muted-foreground">{inv.customer.phone}</div>
          {inv.customer.email && <div className="text-muted-foreground">{inv.customer.email}</div>}
        </div>
        <div>
          <div className="overline text-gold mb-1">Delivery Address</div>
          <div className="text-muted-foreground">{inv.delivery_address.address}{inv.delivery_address.landmark ? `, ${inv.delivery_address.landmark}` : ""}</div>
          <div className="text-muted-foreground">{inv.delivery_address.city} - {inv.delivery_address.pincode}</div>
        </div>
      </div>

      <table className="w-full text-sm">
        <thead>
          <tr className="bg-beige text-navy text-left"><th className="p-2.5">Item</th><th className="p-2.5 text-center">Qty</th><th className="p-2.5 text-right">Amount</th></tr>
        </thead>
        <tbody>
          {inv.items.map((it, i) => (
            <tr key={i} className="border-b border-black/5">
              <td className="p-2.5">
                <div className="text-navy">{it.name}{it.variant ? ` (${it.variant})` : ""}</div>
                {(it.customizations?.length > 0 || it.add_ons?.length > 0) && <div className="text-xs text-muted-foreground">{[...it.customizations, ...it.add_ons].map((o) => o.name).join(", ")}</div>}
              </td>
              <td className="p-2.5 text-center">{it.quantity}</td>
              <td className="p-2.5 text-right">{rupee(it.total)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="flex justify-end mt-4">
        <div className="w-64 text-sm space-y-1.5">
          <Row l="Subtotal" v={rupee(inv.subtotal)} />
          {inv.discount > 0 && <Row l="Discount" v={`- ${rupee(inv.discount)}`} />}
          <Row l="GST (5%)" v={rupee(inv.tax)} />
          <Row l="Delivery" v={inv.delivery_fee === 0 ? "Free" : rupee(inv.delivery_fee)} />
          <div className="flex justify-between font-semibold text-navy text-base border-t border-navy pt-2 mt-2"><span>Grand Total</span><span>{rupee(inv.grand_total)}</span></div>
        </div>
      </div>
      <div className="mt-5 text-xs text-muted-foreground flex justify-between border-t border-dashed border-black/15 pt-3">
        <span>Payment: <span className="capitalize font-medium text-navy">{inv.payment_method}</span> · {inv.payment_status}</span>
        <span>Thank you for dining with us!</span>
      </div>
    </div>
  );
}
function Row({ l, v }) { return <div className="flex justify-between text-muted-foreground"><span>{l}</span><span className="text-navy">{v}</span></div>; }
